{
  "userProfileNotificationsTitle": "Your notifications",
  "removeAny": "Supprimer",
  "displayTheAdDoc": "Afficher le document"
}
